export const validate = (formData, requiredFields) => {
  const newErrors = {} as any;
  requiredFields.forEach((field) => {
    if (!formData[field])
      newErrors[field] = `${field.replace('_', ' ')} is required`;
  });

  if (!formData.is_current && !formData.end_date) {
    newErrors.end_date = 'end date is required';
  }

   if (!formData.is_current && !formData.end_year) {
     newErrors.end_year = 'end year is required';
   }


if (formData.end_date) {
  const date = new Date(Date.parse(`${formData.end_date} 1, 2012`));
  if (isNaN(date.getTime())) {
    newErrors.end_date = 'invalid date format';
  }
}

if (formData.start_date) {
  const date = new Date(Date.parse(`${formData.start_date} 1, 2012`));
  if (isNaN(date.getTime())) {
    newErrors.start_date = 'invalid date format';
  }
}

if (formData.end_year && !formData.is_current) {
  if (isNaN(formData.end_year) || formData.end_year < 1900 || formData.end_year > 2100) {
    newErrors.end_year = 'invalid year format';
  }
}

if (formData.start_year && !formData.is_current) {
  if (isNaN(formData.start_year) || formData.start_year < 1900 || formData.start_year > 2100) {
    newErrors.start_year = 'invalid year format';
  }
}



  return newErrors;
};
